export const REVIEW_CONSTANTS = {
  title: "Trusted by Leading Enterprises",
  desc: "Enterprise-grade cloud infrastructure, fully managed and secure for your business needs",
  list: [
    {
      text: "“OneMind helped us reduce cloud spend by 30% while improving service delivery.”",
      name: "Leading Credit Union",
      designation: "CTO",
    },
    {
      text: "“MOST gave us OpenStack without the operational headaches. We run faster and sleep better.”",
      name: "Global NMS Company",
      designation: "VP Engineering",
    },
  ],
};
